import config from "../../config";
const baseUrl = config.baseUrl;

export const LabUrls = {

  LAB_ADD: baseUrl + "/patientLab",
  LAB_EDIT: baseUrl + "/patientLab",
  LAB_LIST: baseUrl + "/patientLab",
  LAB_DELETE: baseUrl + "/patientLab",
  LAB_GETBYID: baseUrl + "/patientLab",
  LAB_DROPDOWN: baseUrl + "/patients/dropdown",
  LAB_ROLLBACK: baseUrl + "/patientLab/rollback",
  LAB_DELETE_HARD: baseUrl + "/patientLab",
  LAB_STATUS: baseUrl + "/patientLab",
  LAB_ADD_DROPDOWN: baseUrl + "/labDiagnosis/dropdown",

};
